import { render, staticRenderFns } from "./forums-comments.vue?vue&type=template&id=60c684c4&"
import script from "./forums-comments.vue?vue&type=script&lang=js&"
export * from "./forums-comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports